










import Vue from 'vue';
import Component from 'vue-class-component';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const UserRepository = RepositoryFactory.get('user');

@Component
export default class Finish extends Vue {
  // Loadingの表示，非表示の制御
  toggleLoading(params: { is_loading: boolean; time: number }): void {
    this.$emit('toggleLoading', params);
  }

  async mounted(): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });

    await UserRepository.logout();
    await this.$store.commit('setUser', null);
    await this.$store.commit('setRemember', false);
    await this.$store.commit('setLimit', 0);
    await this.$store.commit('setApiToken', null);
    await this.$store.commit('answer/setAnswers', {});

    window.scrollTo(0, 0);
    this.toggleLoading({ is_loading: false, time: 0.5 });
  }
}
